export default __webpack_public_path__ + "locales/cs/MainBar.json?hash=7c754751c976ed363b2fd10946b1f7cb";